namespace $ { export class $piterjs_link extends $mol_link {

	/**
	 *  ```
	 *  target \_blank
	 *  ```
	 **/
	target() {
		return "_blank"
	}

	/**
	 *  ```
	 *  sub / <= Button
	 *  ```
	 **/
	sub() {
		return [this.Button()] as readonly any[]
	}

	/**
	 *  ```
	 *  Button $mol_button_major title <= title
	 *  ```
	 **/
	@ $mol_mem
	Button() {
		return (( obj )=>{
			obj.title = () => this.title()
			return obj
		})( new this.$.$mol_button_major(  ) )
	}

} }
